import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fury-statcommandlivre',
  templateUrl: './statcommandlivre.component.html',
  styleUrls: ['./statcommandlivre.component.scss']
})
export class StatcommandlivreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
